module.exports = __webpack_public_path__ + "static/media/icon-transportadoras.016184fa.svg";